import React from 'react';
import AIComposeToolbar from './AIComposeToolbar';

export default function AIComposePreview({
  subject,
  body,
  streaming = false,
  loading = false,
  error = '',
  onAction,
  disabled = false,
}) {
  const empty = !subject && !body && !streaming && !loading;

  return (
    <section className="aic-preview" aria-live="polite">
      <div className="aic-preview-head">
        <strong>Preview</strong>
        {(loading || streaming) && <span className="aic-typing">Writing</span>}
      </div>

      {error ? <div className="aic-error">{error}</div> : null}

      {empty && !error ? (
        <div className="aic-preview-body" style={{ color: '#5f6368' }}>
          Generated subject and body will appear here.
        </div>
      ) : (
        <>
          {subject ? (
            <div className="aic-preview-subject">
              Subject: <b>{subject}</b>
            </div>
          ) : null}
          <div className={`aic-preview-body${streaming ? ' aic-typing' : ''}`}>
            {body || (streaming || loading ? '' : '—')}
          </div>
          {(subject || body) && !loading ? (
            <AIComposeToolbar disabled={disabled || streaming} onAction={onAction} />
          ) : null}
        </>
      )}
    </section>
  );
}
